import MyDialog from "~/mui/MyDialog";
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateProjectBusinessPlan } from '~/providers/api';
import { IAdminProject } from "~/providers/admin-interfaces";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
}

interface IAdminChangePlanTypeModal {
	projectData: IAdminProject;
	switchToProgram: IAdminProject["businessPlanType"];
	onSave?: (lastUpdate: string, businessPlanType: IAdminProject["businessPlanType"]) => void;
	onClose?: () => void;
}

export default function AdminChangePlanTypeModal({
	projectData = null,
	switchToProgram,
	onSave = () => {},
	onClose = () => {},
}: IAdminChangePlanTypeModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
	});

	function getDesc() {
		switch (switchToProgram) {
			case "basic":
				return trans("adminChangePlanTypeModal.switchToBasic");

			case "vip":
				return trans("adminChangePlanTypeModal.switchToVIP");

			case "technical":
				return trans("adminChangePlanTypeModal.switchToTechnical");

			case "internal":
				return trans("adminChangePlanTypeModal.switchToInternal");

			default:
		}

		return "";
	}

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const updateData = await apiUpdateProjectBusinessPlan(projectData.id, {
			businessPlanType: switchToProgram,
			lastUpdate: projectData.lastUpdate,
		}, lang);

		if (updateData.noErrors) {
			onSave(updateData.data.lastUpdate, updateData.data.businessPlanType);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: updateData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("adminChangePlanTypeModal.title")} onClose={onClose} onSave={dialogOnSave} className="adminChangePlanTypeModal" dialogLoading={state.dialogLoading}
		errorMsg={state.errorMsg} saveCaption={trans("adminChangePlanTypeModal.saveBtn")} minWidth="300px">
		<p>
			{ getDesc() }
		</p>
	</MyDialog>;
}
